<template>
  <CardSection
    :title="title"
    :actions="[
      {
        label: $t('common.Remove'),
        onAction: () => $emit('remove'),
        disabled: readonly
      }
    ]"
  >
    <FormLayout v-if="def">
      <Select
        :label="$t('common.Type')"
        searchable
        :options="filterTypes"
        :value="data.key"
        :disabled="readonly"
        @change="val => changeType(val)"
      />
      <Select
        v-if="def.type !== 'boolean'"
        :label="$t('common.Operator')"
        searchable
        :options="filterOperators"
        :disabled="readonly"
        v-model="data.operator"
        :placeholder="$t('common.Choose an operator')"
      />
      <TextField
        v-if="def.type === 'text'"
        :label="$t('common.Value')"
        :multiline="def.multiline"
        :disabled="readonly"
        :value="value"
        @input="val => setValue(val)"
      />
      <Select
        v-if="def.type === 'list'"
        :label="$t('common.Value')"
        searchable
        tags
        :options="listOptions"
        :value="value"
        :disabled="readonly"
        multiple
        @change="val => setValue(val)"
        :placeholder="$t('common.Choose one or more values')"
      />
      <Select
        v-if="def.type === 'boolean'"
        :label="$t('common.Value')"
        :options="[
          { value: 'true', label: $t('common.True') },
          { value: 'false', label: $t('common.False') }
        ]"
        :disabled="readonly"
        :value="value"
        @change="val => setValue(val)"
        :placeholder="$t('common.Choose a value')"
      />
    </FormLayout>
  </CardSection>
</template>

<script>
import {
  getAvailableFilters,
  getFilterById,
  resolveListOptions
} from '../data/filters.ts'

export default {
  inject: ['$t'],
  props: {
    doc: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    index: {
      type: Number
    },
    readonly: {
      type: Boolean
    }
  },
  computed: {
    def() {
      return getFilterById(this.data.key)
    },
    title() {
      return this.index === 0 ? this.$t('common.if') : this.$t('common.and')
    },
    filterTypes() {
      return getAvailableFilters(this.doc).map(d => {
        return {
          value: d.id,
          label: d.label,
          description: d.description
        }
      })
    },
    filterOperators() {
      return this.def.operators
    },
    value() {
      const {data, def} = this
      if (def.type === 'list') {
        if (typeof data.value === 'string') {
          return data.value.split(',')
        }
        return []
      }
      return data.value
    },
    listOptions() {
      if (this.def.type === 'list') {
        return resolveListOptions(this.def, true)
      }
      return []
    }
  },
  methods: {
    changeType(type) {
      this.data.value = null
      this.data.key = type
    },
    setValue(value) {
      const {data, def} = this
      if (def.type === 'list') {
        data.value = value.join(',') || null
      } else {
        data.value = value
      }
    }
  }
}
</script>
